// extracted by mini-css-extract-plugin
export default {"addToCartControl":"lca-z","giftCard":"mca-z","btnContainer":"nca-z","cartButton":"oca-z","disabled":"pca-z","stockMessage":"qca-z"};